import { render, staticRenderFns } from "./BancoDeCartasICCriar.vue?vue&type=template&id=d8729bf0"
import script from "./BancoDeCartasICCriar.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasICCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports